import React, { ChangeEvent } from "react";
import { Input } from "../common/Input";
import { sanitizeNumberValue } from "../../utils/replacement";
import { FormFieldError } from "../../utils/formsUtils";
import styles from "./styles.module.scss";
import { useProfileStore } from "../../features/initialRegistration/profileStore";
import { useShallow } from "zustand/react/shallow";

export const DEFAULT_PHONE_NUMBER_PATTERN = "[0-9]*";
export const INDONESIA_PHONE_NUMBER_PATTERN = "^8[0-9]*$";

type PhoneNumberProps = {
  error: FormFieldError;
  id: string;
  label: string;
  maxLength: number;
  onBlur: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyPressed?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onPhoneNumberChange: (value: string) => void;
  phoneNumberDisabled: boolean;
  value?: string;
};

export const PhoneNumber = ({
  error,
  id,
  label,
  maxLength,
  phoneNumberDisabled,
  onBlur,
  onKeyPressed,
  onPhoneNumberChange,
  value,
}: PhoneNumberProps) => {
  const country = useProfileStore(useShallow((state) => state.country));
  const handlePhoneNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) =>
    onPhoneNumberChange &&
    onPhoneNumberChange(sanitizeNumberValue(event.target?.value));

  const pattern =
    country === "id-ID"
      ? INDONESIA_PHONE_NUMBER_PATTERN
      : DEFAULT_PHONE_NUMBER_PATTERN;

  return (
    <div className={styles.phoneNumberWrapper}>
      <Input
        disabled={phoneNumberDisabled}
        required
        error={error}
        label={label}
        id={id}
        maxLength={maxLength}
        name="mobile"
        noLabelMargin
        type="tel"
        value={value || ""}
        placeholder=""
        onBlur={onBlur}
        onChange={handlePhoneNumberChange}
        onKeyDown={onKeyPressed}
        inputMode={"numeric"}
        pattern={pattern}
      />
    </div>
  );
};
